


import styled from "styled-components"
import {GoCheck} from "react-icons/go"
import { FaCheck } from "react-icons/fa";
const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;


    .box{
        width: 22px;
        height: 22px;
        border-radius: 3px;
        border: 2px solid ${({theme}) => theme.mainTextColor};
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        .check-icon{
            font-size: .9rem;
            color:#000;
        }
    }

    .label{
        font-size: ${({fontSize}) => fontSize};
        font-weight: ${({fontWeight}) => fontWeight};
    }
`

const InputCheckbox = ({data, handleClick, labelText, fontSize="12px", fontWeight="var(--font-weight-xl)"}) => {

  return (
    <Container fontSize={fontSize} fontWeight={fontWeight}>
        <div className="box" onClick={handleClick}>{data && <FaCheck className="check-icon"/>}</div>
        <div className="label">{labelText}</div>
    </Container>
  )
}

export default InputCheckbox